


































import { defineComponent, ref } from "@vue/composition-api";
import { VaultCategory } from "@scrile/api-provider/dist/api/VaultsProvider";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import PageTitle from "@/components/PageTitle";
import VaultCategoryList from "../VaultCategoryList";
import VaultCreateCategoryModal from "../VaultCreateCategoryModal";

export default defineComponent({
  name: "VaultCategories",
  components: {
    PageTitle,
    BaseButton,
    BaseIcon,
    VaultCategoryList,
    VaultCreateCategoryModal,
  },
  props: {
    categories: { type: Array as () => VaultCategory[], required: true },
    enableScroll: { type: Boolean, required: true },
    categoriesCount: { type: Number, default: 0 },
    filesCount: { type: Number, default: 0 },
  },
  setup() {
    const showCreateModal = ref(false);

    return {
      showCreateModal,
    };
  },
});
